import React, { Children, Component } from 'react'
import PropTypes from 'prop-types'
import { Howl } from 'howler'

const DEFAULT_KEY = 'default'

export default class AudioProvider extends Component {
  static propTypes = {
    audioKey: PropTypes.string,
    sources: PropTypes.objectOf(PropTypes.string).isRequired,
    sprite: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  }

  static defaultProps = {
    audioKey: DEFAULT_KEY,
  }

  static childContextTypes = {
    audio: PropTypes.object,
  }

  static contextTypes = {
    audio: PropTypes.object,
  }

  getChildContext() {
    const { audioKey } = this.props

    return {
      audio: {
        ...this.context.audio,
        [audioKey]: this[audioKey],
      },
    }
  }

  componentWillMount() {
    const { audioKey, sources, sprite } = this.props
    this[audioKey] = {}

    Object.keys(sources).forEach(key => {
      const src = sources[key]
      this[audioKey][key] = new Howl({ src })
    })
  }

  componentWillUnmount() {
    const { audioKey, sources } = this.props

    Object.keys(sources).forEach(key => {
      this[audioKey][key].unload()
    })
  }

  render() {
    return Children.only(this.props.children)
  }
}

export const connectAudio = (audioKey = DEFAULT_KEY) => WrappedComponent =>
  class ConnectedAudio extends Component {
    static contextTypes = {
      audio: PropTypes.object,
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          audio={this.context.audio[audioKey]}
        />
      )
    }
  }



// WEBPACK FOOTER //
// ./src/components/AudioProvider.js